<template>
    <section class="mainContainer">
        <div class="cardsContainer">
            <BaseFormCard v-bind:formConfig="firstFormConfig" v-on:submit="firstFormConfig.onSubmit()"></BaseFormCard>
            <BaseCardDivider v-bind:dividerConfig="dividerConfig"></BaseCardDivider>
            <BaseFormCard v-bind:formConfig="secondFormConfig" v-on:submit="secondFormConfig.onSubmit()"></BaseFormCard>
            <BaseCardDivider v-bind:dividerConfig="dividerConfig"></BaseCardDivider>
            <BaseFormCard v-bind:formConfig="thirdFormConfig" v-on:submit="thirdFormConfig.onSubmit()"></BaseFormCard>
        </div>
        <div class="btnContainer">
            <v-btn class="text-none" dark color="#C4170C" to="/">Voltar</v-btn>
        </div>
    </section>
</template>

<script>
import BaseFormCard from './BaseFormCard'
import BaseCardDivider from './BaseCardDivider'
import cpfRule from '../utils/rules/cpf'
import cellphoneRule from '../utils/rules/cellphone'
import maskUtils from '../utils/masks'
import router from '../router/index'

export default {
   name:'FormCardsContainer',
   data: () => ({
       dividerConfig:{
           width:'2px',
           height:'300px',
           text:'OU'
       },
       firstFormConfig:{
           valid:false,
           submitLabel:"Consultar Serviço",
           firstInput:{
               value: '',
               rules: cellphoneRule,
                inputMask:function (event){
                    let maskedValue = maskUtils.cellphoneMask(event.target.value)
                    this.value = maskedValue
                },
               label: 'Telefone'
           },
           secondInput:{
               value:'',
               rules: cpfRule,
               inputMask:function(event){
                    let maskedValue = maskUtils.cpfMask(event.target.value)
                    this.value = maskedValue
               },
               label: 'CPF'
           },
           onSubmit:function(){
               if(this.valid){
                   const cellphone = this.firstInput.value
                   const cpf = this.secondInput.value
                   const rawCellphone = cellphone.replace(/\D/g, "")
                   const rawCpf = cpf.replace(/\D/g, "")
                   router.push({path:`listar-agendamento/${null}/${rawCpf}/${rawCellphone}`})
               }
           }
       },
       secondFormConfig:{
            valid:false,
            submitLabel:"Consultar Serviço",
            firstInput:{
                value: '',
                rules: [v => !!v || 'Informe um protocolo'],
                inputMask:function(){
                    let maskedValue = maskUtils.numberMask(event.target.value)
                    this.value = maskedValue
                },
                label: 'Número de protocolo'
            },
            secondInput:{
                value:'',
                rules: cpfRule,
                inputMask:function(event){
                    let maskedValue = maskUtils.cpfMask(event.target.value)
                    this.value = maskedValue
                },
                label: 'CPF'
           },
            onSubmit:function(){
                if(this.valid){
                    const protocol = this.firstInput.value
                    const cpf = this.secondInput.value
                    const rawCpf = cpf.replace(/\D/g, "")
                    router.push({path:`listar-agendamento/${protocol}/${rawCpf}/${null}`})
               }
           }
       },
       thirdFormConfig:{
            valid:false,
            submitLabel:"Consultar Serviço",
            firstInput:{
                value: '',
                rules: [v => !!v || 'Informe um protocolo'],
                inputMask:function(){
                    let maskedValue = maskUtils.numberMask(event.target.value)
                    this.value = maskedValue
                },
                label: 'Número de protocolo'
            },
            secondInput:{
                value:'',
                rules: cellphoneRule,
                inputMask:function(event){
                    let maskedValue = maskUtils.cellphoneMask(event.target.value)
                    this.value = maskedValue
                },
                label: 'Telefone'
           },
            onSubmit: function(){
                if(this.valid){
                    const protocol = this.firstInput.value
                    const cellphone = this.secondInput.value
                    const rawCellphone = cellphone.replace(/\D/g, "")
                    router.push({path:`listar-agendamento/${protocol}/${null}/${rawCellphone}`})
               }
           }
       }
   }),
    components: {BaseFormCard,BaseCardDivider}
}
</script>

<style scoped>
    .mainContainer{
        display: flex;
        flex-direction: column;
    }

    .cardsContainer{
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 80vh;
    }

    .cardsContainer .card{
        margin-right: 10px;
        margin-left: 10px;
        height: 300px;
        width: 300px;
    }

    .btnContainer{
        padding: 10px;
    }
    @media (max-width: 1024px) {
        .cardsContainer .dividerContainer{
            display: none;
        }

        .cardsContainer{
            flex-direction: column;
        }

        .cardsContainer .card{
            margin-top: 10px;
        }
    }   
</style>